module.exports = __webpack_public_path__ + "static/media/iPad-Pro_Magazine.1195c73b.png";